<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class AlignMenus extends Vue {
        get menuList() {
            let list = [
                { key: "OCR", label: this.$t("OCR"), isRender: !window.EDCONFIG.IS_SDK },
                {
                    key: "table",
                    label: this.$t("table"),
                    // img: 'ai-table',
                },
                {
                    key: "list",
                    label: this.$t("list"),
                    // img: 'ai-list',
                },
                {
                    key: "portrait",
                    label: this.$t("portrait"),
                    // img: 'ai-portrait',
                },
                {
                    key: "story",
                    label: this.$t("story"),
                    // img: 'ai-story',
                },
                {
                    key: "pest",
                    label: this.$t("pest"),
                    // img: 'ai-pest',
                },
                {
                    key: "canvas",
                    label: this.$t("canvas"),
                    // img: 'ai-canvas',
                },
            ];

            list = list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true));
            return {
                // container: "",
                list,
            };
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        handleClicks(...args) {
            let key = args[0];
            let event = args[1];
            const toAiImg = (type) => {
                this.$bus.$emit("showAIPanel", true);
                this.$nextTick(() => {
                    this.$bus.$emit("aiClickImglist", type);
                });
            };
            const trackClick = (type) => {
                this.sensors.track("clickAItoolbar", {
                    Catalogues: "AI",
                    click_type: type,
                });
            };
            let clickEvents = new Map([
                [
                    "table",
                    () => {
                        toAiImg("table");
                        trackClick("Table");
                    },
                ],
                [
                    "list",
                    () => {
                        toAiImg("list");
                        trackClick("List");
                    },
                ],
                [
                    "portrait",
                    () => {
                        toAiImg("portrait");
                        trackClick("User Profile");
                    },
                ],
                [
                    "story",
                    () => {
                        toAiImg("story");
                        trackClick("User Story");
                    },
                ],
                [
                    "pest",
                    () => {
                        toAiImg("pest");
                        trackClick("PEST Analysis");
                    },
                ],
                [
                    "canvas",
                    () => {
                        toAiImg("canvas");
                        trackClick("Lean Canvas");
                    },
                ],
                [
                    "OCR",
                    () => {
                        event.stopPropagation();
                        this.showOCRDialog();
                    },
                ],
            ]);
            console.log(key);
            this.closeDrop();
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }

        showOCRDialog() {
            // 打开文字识别弹窗
            this.showDialog("OCRModal");

            this.sensors.track("clickOcr", {
                Catalogues: "AI",
            });
        }

        showDialog(target) {
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: target,
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "OCR": "OCR图片文字提取",
    "table": "表格",
    "list": "列表",
    "portrait": "用户画像",
    "story": "用户故事",
    "pest": "PEST分析",
    "canvas": "精益画布"
  },
  "en": {
    "OCR": "OCR Image Text Extraction",
    "table": "Table",
    "list": "List",
    "portrait": "User Profile",
    "story": "User Story",
    "pest": "PEST Analysis",
    "canvas": "Lean Canvas"
  },
  "fr": {
    "OCR": "Extraction de texte d'image via OCR",
    "table": "Tableau",
    "list": "Liste",
    "story": "Récit utilisateur",
    "portrait": "Profil utilisateur",
    "pest": "Analyse PEST",
    "canvas": "Lean canvas"
  },
  "de": {
    "OCR": "OCR Bild-Text-Extraktion",
    "table": "Tabelle",
    "list": "Liste",
    "pest": "STEP-Analyse",
    "canvas": "Lean Canvas",
    "story": "User Story",
    "portrait": "Benutzerprofil"
  },
  "jp": {
    "OCR": "OCR画像テキスト抽出",
    "table": "テーブル",
    "list": "リスト",
    "pest": "PEST分析",
    "canvas": "リーンキャンバス",
    "story": "ユーザーストーリー",
    "portrait": "ユーザープロファイル"
  },
  "es": {
    "OCR": "Extracción de texto de imágenes con OCR",
    "table": "Tabla",
    "list": "Lista",
    "pest": "Análisis PEST",
    "canvas": "Lienzo en blanco",
    "story": "Historia de usuario",
    "portrait": "Perfil de usuario"
  },
  "pt": {
    "OCR": "Extração de texto de imagem por OCR",
    "table": "Tabela",
    "list": "Lista",
    "pest": "Análise PEST",
    "canvas": "Lean Canvas",
    "story": "História do usuário",
    "portrait": "Perfil do usuário"
  },
  "it": {
    "OCR": "Estrazione del testo da immagine OCR",
    "table": "Tabella",
    "list": "Elenco",
    "pest": "Analisi PEST",
    "canvas": "Lean Canvas",
    "story": "Storia utente",
    "portrait": "Profilo utente"
  },
  "tw": {
    "OCR": "OCR 影像文字擷取",
    "table": "表格",
    "list": "清單",
    "pest": "PEST分析",
    "canvas": "精實畫布",
    "story": "使用者案例",
    "portrait": "使用者設定檔"
  },
  "kr":{
    "OCR": "OCR 이미지 텍스트 추출"
  }
}
</i18n>
